import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourJobApi } from '../api/labourJobApi'; 
import { RootState } from '..';

export interface LabourJobState {
  labourJobDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourJobState = {
  labourJobDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourJobSlice = createSlice({
  name: 'labourJob',
  initialState,
  reducers: {
    setJobDetails: (state, action: PayloadAction<any>) => {
      state.labourJobDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourJobApi.endpoints.createLabourServiceDetail.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourJobApi.endpoints.createLabourServiceDetail.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourJobDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourJobApi.endpoints.createLabourServiceDetail.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setJobDetails, setLoading, setError, reset } = labourJobSlice.actions;
export const getJobDetails = (state: RootState) => state.labour.data;
export const getJobDetailsTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourJobSlice.reducer;